import { Component } from "react";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import "./Intervention.css";
import withAuth from "../../components/withAuth";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import StartInterventionModal from "../../components/Interventions/StartInterventionModal";
import PauseInterventionModal from "../../components/Interventions/PauseInterventionModal";
import DetailTab from "../../components/Interventions/InterventionTabs/DetailTab";
import FixedTab from "../../components/Interventions/InterventionTabs/ReportTab";
import VariableTab from "../../components/Interventions/InterventionTabs/VariableTab";
import {
    fieldValueChange,
    addOrRemoveBloc,
    getStartedWorkOrder,
    setImputationRedirectionModalOpenned,
    loadInterventionModel,
    setPreview,
    setControlSignature,
    setSignature,
    setExpandedBloc,
    validateBlocs,
} from "../../redux/intervention/interventionActions";
import { loadCurrentTimeSlot } from "../../redux/imputationInterventionRel/imputationInterventionRelActions";
import {
    pauseIntervention,
    startIntervention,
    synchronizeIntervention,
    preview,
    controlSignature,
} from "../../redux/intervention/interventionEditionActions";
import { getGpsPosition, getDefaultPosition } from "../../redux/gps/gpsActions";
import FooterFixedOnScreen from "../Layout/FooterFixedOnScreen";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import { initializeDays } from "../../redux/day/dayEditionActions";
import { clone } from "../../utils";
import { throwWarning } from "../../lib/error_helper";
import InterventionAlreadyInProgressModal from "../../components/Interventions/InterventionAlreadyInProgressModal";
import ImputationRedirectionModal from "../../components/Interventions/ImputationRedirectionModal";
import { getStateAccessor } from "../../lib/evaluateStringAsCodeHelper";
import { faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import BatteryIcon from "@mui/icons-material/Battery80";
import { loadProductCategories } from "../../redux/product/productActions";
import { getCurrentFunctionName } from "../../performanceModeManager";
import { isInterventionTerminated } from "../../redux/intervention/interventionStatusActions";
import { SIGNATURES_BLOC_TYPE_CODE } from "../../redux/intervention/interventionConstants";

const styles = {
    root: {
        minWidth: "40px",
        fontSize: "0.5em",
    },
};

class Intervention extends Component {
    constructor(props) {
        super(props);

        if (!this.props.intervention) this.props.history.push("/interventions");

        this.state = {
            selectedTab: 0,
            startInterventionModalOpenned: false,
            pauseInterventionModalOpenned: false,
            interventionInProgressModalOpenned: false,
            interventionToPause: null,
            timeSlotToEnd: null,
            startInProgress: false,
        };

        this.props.loadInterventionModel();
        this.props.loadProductCategories();
        this.cancelPreview();
        this.cancelControlSignature();
        this.cancelSignature();
    }

    componentDidMount() {
        if (navigator.geolocation) this.props.getGpsPosition.bind(this.props.authorizedApps);

        if (this.props.blocs.length > 0 && this.props.blocTypes.length > 0)
            this.props.loadCurrentTimeSlot(this.props.blocs, this.props.blocTypes, this.props.activeUser);

        this.props.initializeDays(this.props.activeUser.id);
    }

    fieldValueChange(blocId, fieldId, value) {
        this.props.fieldValueChange(
            blocId,
            fieldId,
            value,
            this.props.blocs,
            this.props.activeUser.id,
            this.props.intervention
        );
    }

    addOrRemoveBloc(blocTypeId, blocId, addBlocAction = true) {
        this.props.addOrRemoveBloc(
            blocTypeId,
            blocId,
            addBlocAction,
            this.props.blocs,
            this.props.blocTypes,
            this.props.intervention,
            this.props.activeUser,
            getStateAccessor(this.props)
        );
    }

    handleChange = (event, value) => {
        this.setState({ selectedTab: value });
        this.props.setExpandedBloc(null);
    };

    handleChangeIndex = (index) => {
        this.setState({ selectedTab: index });
        this.props.setExpandedBloc(null);
    };

    preview() {
        this.props.preview(this.props.history);
    }

    cancelPreview() {
        this.props.setPreview(false);
    }

    cancelControlSignature() {
        this.props.setControlSignature(false);
    }

    controlSignature() {
        this.props.validateBlocs(
            this.props.blocs,
            this.props.intervention,
            this.props.blocTypes,
            this.props.activeUser,
            getStateAccessor(this.props),
            true
        );
        this.props.controlSignature(this.props.history);
    }

    cancelSignature() {
        this.props.setSignature(false);
    }

    synchronize() {
        this.props.synchronizeIntervention(
            this.props.intervention,
            this.props.blocs,
            this.props.activeUser,
            this.props.blocTypes,
            this.props.history,
            getStateAccessor(this.props)
        );
        this.forceUpdate();
    }

    start(startDate, startTime) {
        this.pauseInterventionInProgress(null, null, startDate, startTime).then((interventionIsInProgress) => {
            if (interventionIsInProgress) return;

            if (this.state.startInterventionModalOpenned && startDate) {
                if (!this.state.startInProgress) {
                    this.setState({ startInProgress: true });
                    let gpsPosition = getDefaultPosition();
                    if (this.props.gpsPosition && this.props.gpsPosition.coords)
                        gpsPosition = {
                            lat: this.props.gpsPosition.coords.latitude,
                            lon: this.props.gpsPosition.coords.longitude,
                        };

                    let imputationInformations = {
                        startDate: startDate,
                        startTime: startTime,
                        currentDay: this.props.currentDay,
                        gpsPosition: gpsPosition,
                    };

                    this.props
                        .startIntervention(
                            this.props.intervention,
                            imputationInformations,
                            this.props.blocTypes,
                            this.props.activeUser,
                            this.props.history,
                            getStateAccessor(this.props)
                        )
                        .then(() => {
                            this.setState({ startInProgress: false });
                        })
                        .catch((error) => {
                            console.error("Une erreur est survenue :", error);
                            this.setState({ startInProgress: false });
                        });

                    this.forceUpdate();
                    this.setState({
                        startInterventionModalOpenned: false,
                    });
                }
            } else {
                this.props.getGpsPosition(this.props.authorizedApps);
                this.openStartInterventionModal();
            }
        });
    }

    openStartInterventionModal() {
        this.setState({
            startInterventionModalOpenned: true,
        });
    }

    closeStartInterventionModal() {
        this.setState({
            startInterventionModalOpenned: false,
        });
    }

    pauseInterventionInProgress(endDate, endTime, startDate, startTime) {
        return new Promise((resolve) => {
            if (this.state.pauseInterventionModalOpenned) {
                let timeSlotToEnd = clone(this.state.timeSlotToEnd);
                timeSlotToEnd.endDate = endDate;
                timeSlotToEnd.endTime = endTime;

                return this.props
                    .pauseIntervention(
                        this.state.interventionToPause,
                        timeSlotToEnd,
                        this.state.interventionToPause.report_block_ids,
                        this.props.activeUser,
                        this.props.blocTypes,
                        this.props.history,
                        getStateAccessor(this.props),
                        false,
                        true
                    )
                    .then(() => {
                        this.forceUpdate();
                        this.setState({
                            pauseInterventionModalOpenned: false,
                            interventionToPause: null,
                            timeSlotToEnd: null,
                        });

                        this.props.setImputationRedirectionModalOpenned(true);
                        return resolve(false);
                    })
                    .catch(() => {
                        return resolve(false);
                    });
            } else {
                getStartedWorkOrder().then((intervention) => {
                    if (intervention)
                        this.props
                            .loadCurrentTimeSlot(
                                intervention.report_block_ids,
                                this.props.blocTypes,
                                this.props.activeUser
                            )
                            .then((timeSlot) => {
                                if (timeSlot) {
                                    if (this.state.startInterventionModalOpenned) {
                                        let timeSlotToEnd = clone(timeSlot);
                                        timeSlotToEnd.endDate = startDate;
                                        timeSlotToEnd.endTime = startTime;
                                        this.props
                                            .pauseIntervention(
                                                intervention,
                                                timeSlotToEnd,
                                                intervention.report_block_ids,
                                                this.props.activeUser,
                                                this.props.blocTypes,
                                                this.props.history,
                                                getStateAccessor(this.props),
                                                false,
                                                false
                                            )
                                            .then(() => {
                                                return resolve(false);
                                            })
                                            .catch((err) => {
                                                console.error(err);
                                                return resolve(true);
                                            });
                                    } else {
                                        let pauseInterventionModalOpenned = false;
                                        let interventionInProgressModalOpenned = false;

                                        if (intervention.mobile_id === this.props.intervention.mobile_id)
                                            pauseInterventionModalOpenned = true;
                                        else interventionInProgressModalOpenned = true;

                                        this.setState({
                                            interventionToPause: intervention,
                                            timeSlotToEnd: timeSlot,
                                            pauseInterventionModalOpenned,
                                            interventionInProgressModalOpenned,
                                        });

                                        return resolve(true);
                                    }
                                }
                            });
                    else return resolve(false);
                });
            }
        });
    }

    closePauseInterventionModal() {
        this.setState({
            pauseInterventionModalOpenned: false,
        });
    }

    closeInterventionInProgressModal() {
        this.setState({
            interventionInProgressModalOpenned: false,
        });
    }

    closeImputationRedirectionModal() {
        this.props.setImputationRedirectionModalOpenned(false);
    }

    getIcon(iconName) {
        if (iconName === "battery") return <BatteryIcon />;
        else if (iconName === "time") return <Icon>timelapse</Icon>;
        else if (iconName === "quote") return <FontAwesomeIcon icon={faFileInvoiceDollar} className="fa-lg" />;
        else if (iconName === "article") return <Icon>shopping_cart</Icon>;
        else if (iconName === "dynamic") return <Icon>library_add</Icon>;
        else if (iconName === "base") return <Icon>assignment</Icon>;
        else return null;
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.intervention.internalState !== nextProps.intervention.internalState ||
            this.props.intervention.state !== nextProps.intervention.state ||
            this.state.selectedTab !== nextState.selectedTab ||
            this.props.blocs.length !== nextProps.blocs.length ||
            this.state.startInterventionModalOpenned !== nextState.startInterventionModalOpenned ||
            this.state.pauseInterventionModalOpenned !== nextState.pauseInterventionModalOpenned ||
            this.state.interventionInProgressModalOpenned !== nextState.interventionInProgressModalOpenned ||
            this.props.currentTimeSlot !== nextProps.currentTimeSlot ||
            this.props.imputationRedirectionModalOpenned !== nextProps.imputationRedirectionModalOpenned ||
            this.props.geolocalisationInProgress !== nextProps.geolocalisationInProgress
        );
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        if (!this.props.intervention) return <div />;

        const { classes } = this.props;

        let categories = [];

        this.props.blocTypes
            .filter((bt) => bt.published)
            .map((bt) => bt.category_id)
            .forEach((c) => {
                if (categories.every((rc) => rc.id !== c.id)) {
                    c.iconElement = this.getIcon(c.icon);
                    categories.push(c);
                }
            });
        let categoryTabs = [];

        categories.sort((a, b) => a.sequence - b.sequence);
        categories.forEach((c, i) => {
            categoryTabs.push({
                name: c.name,
                content: c.removable ? (
                    <VariableTab
                        key={i}
                        category={c}
                        fieldValueChange={this.fieldValueChange.bind(this)}
                        addOrRemoveBloc={this.addOrRemoveBloc.bind(this)}
                        selectedTab={this.state.selectedTab === i + 1}
                    />
                ) : (
                    <FixedTab
                        key={i}
                        category={c}
                        fieldValueChange={this.fieldValueChange.bind(this)}
                        addOrRemoveBloc={this.addOrRemoveBloc.bind(this)}
                        selectedTab={this.state.selectedTab === i + 1}
                    />
                ),
            });
        });

        let blocTypeSignature = this.props.blocTypes.find((bt) => bt.code === SIGNATURES_BLOC_TYPE_CODE);
        let blocSignature;
        if (blocTypeSignature) {
            blocSignature = this.props.blocs.find((b) => b.type_id === blocTypeSignature.id);
        }

        return (
            <div>
                <div className="container-with-footer">
                    <AppBar position="static" color="default">
                        <Tabs
                            value={this.state.selectedTab}
                            onChange={this.handleChange}
                            variant="fullWidth"
                            scrollButtons="auto"
                            indicatorColor="primary"
                            textColor="primary"
                            sx={{
                                "& .MuiTab-root": {
                                    minWidth: "40px",
                                    fontSize: "0.5em",
                                },
                            }}
                        >
                            <Tab
                                classes={classes}
                                label={"Détail"}
                                icon={<FontAwesomeIcon className={"fa-3x"} icon={faInfoCircle} />}
                            />
                            {categories.map((sc, i) => (
                                <Tab
                                    classes={classes}
                                    id={sc.name}
                                    key={i}
                                    icon={sc.iconElement}
                                    label={sc.name}
                                    disabled={this.props.blocs ? this.props.blocs.length <= 0 : true}
                                />
                            ))}
                        </Tabs>
                    </AppBar>
                    <SwipeableViews axis="x" index={this.state.selectedTab} onChangeIndex={this.handleChangeIndex}>
                        <DetailTab />
                        {categoryTabs.map((sc) => sc.content)}
                    </SwipeableViews>
                </div>
                {(this.props.intervention.state === "performed" || this.props.intervention.state === "assigned") &&
                !isInterventionTerminated(this.props.intervention.state, this.props.intervention.internalState) ? (
                    <FooterFixedOnScreen>
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-4 col-4">
                                <Fab onClick={this.synchronize.bind(this)} className="div-center">
                                    <Icon>sync</Icon>
                                </Fab>
                                <span className="floating-btn-text span-center">Synchroniser</span>
                            </div>
                            <div className="offset-lg-3 col-lg-2 offset-md-3 col-md-2 col-sm-4 col-4">
                                <div className="center">
                                    {this.props.intervention.internalState === "started" &&
                                        this.props.intervention.state === "performed" &&
                                        this.props.intervention.tec_manager_id.id === this.props.activeUser.emp_id &&
                                        blocSignature &&
                                        this.props.blocs.length > 0 && (
                                            <div>
                                                <Fab
                                                    onClick={this.controlSignature.bind(this)}
                                                    className="green-button div-center"
                                                >
                                                    <Icon>check</Icon>
                                                </Fab>
                                                <span className="floating-btn-text span-center">
                                                    Contrôle avant signature
                                                </span>
                                            </div>
                                        )}
                                    {this.props.intervention.internalState === "started" &&
                                        this.props.intervention.state === "performed" &&
                                        this.props.intervention.tec_manager_id.id === this.props.activeUser.emp_id &&
                                        !blocSignature &&
                                        this.props.blocs.length > 0 && (
                                            <div>
                                                <Fab
                                                    onClick={this.preview.bind(this)}
                                                    className="green-button div-center"
                                                >
                                                    <Icon>check</Icon>
                                                </Fab>
                                                <span className="floating-btn-text span-center">
                                                    Aperçu avant validation
                                                </span>
                                            </div>
                                        )}
                                </div>
                            </div>
                            {this.props.intervention.internalState !== "started" ||
                            this.props.intervention.state !== "performed" ? (
                                <div className="offset-lg-3 col-lg-2 offset-md-3 col-md-2 col-sm-4 col-4">
                                    <div className="center">
                                        <Fab onClick={this.start.bind(this)} className="div-center" color="primary">
                                            <Icon>play_arrow</Icon>
                                        </Fab>
                                        <span className="floating-btn-text span-center">Démarrer</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="offset-lg-3 col-lg-2 offset-md-3 col-md-2 col-sm-4 col-4">
                                    <div className="center">
                                        <Fab
                                            onClick={this.pauseInterventionInProgress.bind(this)}
                                            className="red-button div-center"
                                            id="btn-pause-intervention"
                                        >
                                            <Icon>pause</Icon>
                                        </Fab>
                                        <span className="floating-btn-text span-center">Interrompre</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </FooterFixedOnScreen>
                ) : null}
                {this.state.startInterventionModalOpenned && (
                    <StartInterventionModal
                        opened={this.state.startInterventionModalOpenned}
                        startIntervention={this.start.bind(this)}
                        closeModal={this.closeStartInterventionModal.bind(this)}
                        gpsInProgress={this.props.geolocalisationInProgress}
                    />
                )}
                {this.state.interventionInProgressModalOpenned && (
                    <InterventionAlreadyInProgressModal
                        interventionInProgress={this.state.interventionToPause}
                        opened={this.state.interventionInProgressModalOpenned}
                        closeModal={this.closeInterventionInProgressModal.bind(this)}
                        openStartInterventionModal={this.openStartInterventionModal.bind(this)}
                    />
                )}
                {this.state.pauseInterventionModalOpenned && (
                    <PauseInterventionModal
                        opened={this.state.pauseInterventionModalOpenned}
                        pause={this.pauseInterventionInProgress.bind(this)}
                        startDate={this.state.timeSlotToEnd ? this.state.timeSlotToEnd.startDate : null}
                        startTime={this.state.timeSlotToEnd ? this.state.timeSlotToEnd.startTime : null}
                        numOT={this.state.interventionToPause ? this.state.interventionToPause.name : null}
                        closeModal={this.closePauseInterventionModal.bind(this)}
                    />
                )}
                {this.props.imputationRedirectionModalOpenned && (
                    <ImputationRedirectionModal closeModal={this.closeImputationRedirectionModal.bind(this)} />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        blocTypes: state.interventions.blocTypes,
        intervention: state.intervention.currentIntervention,
        blocs: state.intervention.blocs,
        activeUser: state.activeUser,
        currentDay: state.current_day,
        gpsPosition: state.gpsInformations.gpsPosition,
        geolocalisationInProgress: state.gpsInformations.geolocalisationInProgress,
        authorizedApps: state.authorizedApps,
        currentTimeSlot: state.intervention.currentTimeSlot,
        loggedEmployee: state.loggedEmployee.loggedEmployee,
        fluidBottles: state.liquidBottles.myLiquidBottles,
        sppFound: state.analysesRisques.sppFound,
        imputationRedirectionModalOpenned: state.interventions.imputationRedirectionModalOpenned,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fieldValueChange: (blocId, fieldId, value, blocs, userId, intervention) =>
            dispatch(fieldValueChange(blocId, fieldId, value, blocs, userId, intervention)),
        addOrRemoveBloc: (blocTypeId, blocId, addBlocAction, blocs, blocTypes, intervention, user, stateAccessor) =>
            dispatch(
                addOrRemoveBloc(blocTypeId, blocId, addBlocAction, blocs, blocTypes, intervention, user, stateAccessor)
            ),
        startIntervention: (intervention, imputationInformations, model, user, history, stateAccessor) =>
            dispatch(startIntervention(intervention, imputationInformations, model, user, history, stateAccessor)),
        synchronizeIntervention: (intervention, blocs, user, blocTypes, history, stateAccessor) =>
            dispatch(synchronizeIntervention(intervention, blocs, user, blocTypes, history, stateAccessor)),
        pauseIntervention: (
            intervention,
            timeSlot,
            blocs,
            user,
            blocTypes,
            history,
            stateAccessor,
            keepLoading,
            currentIntervention
        ) =>
            dispatch(
                pauseIntervention(
                    intervention,
                    timeSlot,
                    blocs,
                    user,
                    blocTypes,
                    history,
                    stateAccessor,
                    keepLoading,
                    currentIntervention
                )
            ),
        preview: (history) => dispatch(preview(history)),
        controlSignature: (history) => dispatch(controlSignature(history)),
        setPreview: (value) => dispatch(setPreview(value)),
        setControlSignature: (value) => dispatch(setControlSignature(value)),
        setSignature: (value) => dispatch(setSignature(value)),
        getGpsPosition: (authorizedApps) => dispatch(getGpsPosition(authorizedApps)),
        loadCurrentTimeSlot: (blocs, blocTypes, user) => dispatch(loadCurrentTimeSlot(blocs, blocTypes, user)),
        throwWarning: (warnObj) => dispatch(throwWarning(warnObj)),
        initializeDays: (userId) => dispatch(initializeDays(userId)),
        setImputationRedirectionModalOpenned: (value) => dispatch(setImputationRedirectionModalOpenned(value)),
        loadProductCategories: () => dispatch(loadProductCategories()),
        loadInterventionModel: () => dispatch(loadInterventionModel()),
        setExpandedBloc: (blocId) => dispatch(setExpandedBloc(blocId)),
        validateBlocs: (blocs, intervention, blocTypes, user, stateAccessor, previewMode) =>
            dispatch(validateBlocs(blocs, intervention, blocTypes, user, stateAccessor, previewMode)),
    };
};

export default compose(withStyles(styles), withAuth, connect(mapStateToProps, mapDispatchToProps))(Intervention);
